import { Text, type TextProps } from '@mantine/core'
import React from 'react'

import { formatDateString, type FormatDateStringProps } from '@flecto/utils'

export type TextDateProps = TextProps & FormatDateStringProps

export function TextDate({ variant = 'date-brief', ...props }: TextDateProps) {
  const formatted = formatDateString({ variant, ...props })

  return <Text {...props}>{formatted}</Text>
}
